package dev.mft.website.composable.header

import androidx.window.core.layout.WindowHeightSizeClass
import androidx.window.core.layout.WindowWidthSizeClass

data class HeaderLayoutConfig(
    val imageSize: Float,
    val titleSize: Float,
    val paragraphSize: Float
) {
    companion object {
        fun getLayoutConfig(
            widthClass: WindowWidthSizeClass,
            heightClass: WindowHeightSizeClass
        ): HeaderLayoutConfig {
            return when (widthClass) {
                // SMARTPHONE
                WindowWidthSizeClass.COMPACT -> when (heightClass) {
                    WindowHeightSizeClass.COMPACT -> HeaderLayoutConfig(
                        imageSize = 0.5f,
                        titleSize = 0.06f,
                        paragraphSize = 0.03f
                    )
                    WindowHeightSizeClass.MEDIUM -> HeaderLayoutConfig(
                        imageSize = 0.65f,
                        titleSize = 0.08f,
                        paragraphSize = 0.05f
                    )
                    else -> HeaderLayoutConfig(
                        imageSize = 0.75f,
                        titleSize = 0.09f,
                        paragraphSize = 0.06f
                    )
                }

                // TABLET
                WindowWidthSizeClass.MEDIUM -> when (heightClass) {
                    WindowHeightSizeClass.COMPACT -> HeaderLayoutConfig(
                        imageSize = 0.5f,
                        titleSize = 0.05f,
                        paragraphSize = 0.03f
                    )
                    WindowHeightSizeClass.MEDIUM -> HeaderLayoutConfig(
                        imageSize = 0.6f,
                        titleSize = 0.06f,
                        paragraphSize = 0.04f
                    )
                    else -> HeaderLayoutConfig(
                        imageSize = 0.7f,
                        titleSize = 0.065f,
                        paragraphSize = 0.04f
                    )
                }

                // PC/DESKTOP
                else -> when (heightClass) {
                    WindowHeightSizeClass.COMPACT -> HeaderLayoutConfig(
                        imageSize = 0.5f,
                        titleSize = 0.06f,
                        paragraphSize = 0.04f
                    )
                    WindowHeightSizeClass.MEDIUM -> HeaderLayoutConfig(
                        imageSize = 0.6f,
                        titleSize = 0.07f,
                        paragraphSize = 0.04f
                    )
                    else -> HeaderLayoutConfig(
                        imageSize = 0.7f,
                        titleSize = 0.09f,
                        paragraphSize = 0.045f
                    )
                }
            }
        }
    }
}